import { useCallback } from 'react'
import { useLocation } from 'wouter'
import { useShallow } from 'zustand/react/shallow'

import { useAppStore, useCADPageStore } from '@/state'
import { useCADQuery } from '../../services/queries/cads'
import { useGetView, useUpdateView } from '../../services/queries/views'
import { useImageData } from '@/pages/CADPage/components/ControlPanel/CreateViewButton/hooks/useImageData'

export const useRetakeView = (viewId?: string | null) => {
  const [, setLocation] = useLocation()
  const { isLoading: isLoadingCad, data: cadData } = useCADQuery()
  const { isLoading: isLoadingView, data: view } = useGetView({ viewId })

  const cadVersionId = cadData?.version?.id
  const documentVersionId = cadData?.documentVersion?.id
  const isLoading = isLoadingCad || isLoadingView

  const imageData = useImageData()
  const viewWorker = useAppStore(useShallow((state) => state.viewWorker))
  const setCadPageState = useCADPageStore(useShallow((state) => state.setState))
  const retakeLocation = useCADPageStore(
    useShallow((state) => state.retakeLocation),
  )

  // update view onSuccess
  const { mutate: updateView, isPending: isViewPending } = useUpdateView({
    onSuccess: () => {
      if (viewWorker && cadVersionId && documentVersionId) {
        void viewWorker.kick(cadVersionId, documentVersionId)
      }

      setCadPageState({
        retakeLocation: null,
        isEditModeActive: false,
        isRetakeModeActive: false,
        screenshotPanelOpen: retakeLocation === 'screenshotPanel',
      })

      if (retakeLocation && retakeLocation !== 'screenshotPanel') {
        setLocation(retakeLocation)
      }
    },
  })

  // retake view
  const retakeView = useCallback(() => {
    if (view && view.id && documentVersionId) {
      updateView({
        viewId: view.id,
        values: {
          ...view,
          name: view.name,
          image_data: imageData,
          source_type: 'screenshot',
          document_page_id: view.document_page ?? null,
        },
      })
    }
  }, [imageData, updateView, view, documentVersionId])

  return { isLoading, isViewPending, retakeView }
}
